import * as React from 'react';
import { Input, RadioButton } from '@cian/ui-kit';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { useDispatch, useSelector } from 'react-redux';

import { getName, getUserStatus } from '../../../selectors/newReview';
import { EUserStatus } from '../../../types/newReview/userStatus';
import { setUserStatus } from '../../../actions/newReview';
import { UserInfo } from '../../../components/NewReviewModal/parts/NewReviewModalReview/parts/UserInfo';
import { setName } from '../../../actions/newReview/nameActions';
import { getFirstName } from '../../../selectors/user';

export const UserInfoContainer = () => {
  const value = useSelector(getUserStatus);
  const initialName = useSelector(getFirstName);
  const name = useSelector(getName) || initialName;
  const dispatch = useDispatch();

  const onStatusChange = React.useCallback(
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    (e: React.ChangeEvent<HTMLInputElement>, _value: any) => {
      dispatch(setUserStatus(e.currentTarget.value as EUserStatus));
    },
    [dispatch],
  );

  const onNameChange = React.useCallback(
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
    (e: React.ChangeEvent<HTMLInputElement>, _value: any) => {
      dispatch(setName(e.currentTarget.value));
    },
    [dispatch],
  );

  return (
    <UiKitContextProvider useStaticDeviceType={true} deviceType="desktop">
      <UserInfo
        title="Расскажите о себе"
        name={
          <Input
            size="M"
            width="100%"
            inline={true}
            onChange={onNameChange}
            placeholder="Например, Иван"
            value={name}
            disabled={!!initialName}
          />
        }
        statuses={[
          <RadioButton
            size="M"
            key={`userStatus_${EUserStatus.Seeker}`}
            checked={value === EUserStatus.Seeker}
            label="В поиске"
            name="userStatus"
            onChange={onStatusChange}
            value={EUserStatus.Seeker}
          />,
          <RadioButton
            size="M"
            key={`userStatus_${EUserStatus.Execute}`}
            checked={value === EUserStatus.Execute}
            label="На стадии сделки"
            name="userStatus"
            onChange={onStatusChange}
            value={EUserStatus.Execute}
          />,
          <RadioButton
            size="M"
            key={`userStatus_${EUserStatus.Owning}`}
            checked={value === EUserStatus.Owning}
            label="Квартира в этом ЖК"
            name="userStatus"
            onChange={onStatusChange}
            value={EUserStatus.Owning}
          />,
        ]}
      />
    </UiKitContextProvider>
  );
};
